module.exports = __webpack_public_path__ + "img/837.99688369.png";